import { Typography } from "@mui/material";

const TypographyPersonalInfoFieldTitle = ({ children }) => {
  return (
    <Typography
      variant="subtitle2"
      sx={{ color: "black", fontWeight: "bold", fontSize: "0.75rem" }}
    >
      {children}
    </Typography>
  );
};

export default TypographyPersonalInfoFieldTitle;
